import { ComponentStyleConfig } from '@chakra-ui/react';

const Textarea: ComponentStyleConfig = {
  defaultProps: {
    variant: 'primary',
  },
  variants: {
    primary: {
      bg: 'input-bg',
    },
  },
};

export default Textarea;
